module.exports = __webpack_public_path__ + "static/media/AAPACN Logo.958a78cd.png";